<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <div class="ac-header">
        Promo Wizard Help
      </div>
      <div class="ac-info-container">
        <div class="ac-info-header">
          Promotion Info
        </div>
        <div class="ac-info-body">
          <b>
            Select what will happen when a member actions the CTA. Customize the CTA text. Under
            “More Details,” add any information you would like. (for example, terms and conditions)
          </b>
        </div>
        <div class="ac-info-body">
          <b>Phone call:</b> Enter a phone number for the member to call.
        </div>
        <div class="ac-info-body">
          <b>Navigate to Website:</b> Provide a link to more information.
        </div>
        <div class="ac-info-body">
          <b>Email a PDF:</b> Send a PDF attachment to your member’s email with more information.
        </div>
      </div>
      <div class="ac-button-container">
        <button
          type="button"
          class="ac-button"
          @click="close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoInfo',
  props: {
    close: Function,
  },
};
</script>
